import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { linkedCountText, linkedRecordCount } from '../../../../../../../../../../shared/helpers/design-context';

@Component({
    selector: 'app-material-test-summary-internal',
    templateUrl: './material-test-summary-internal.component.html',
    styleUrls: ['./material-test-summary-internal.component.scss'],
    standalone: false
})
export class MaterialTestSummaryInternalComponent implements OnInit, OnDestroy {
  @Input() data: any;
  readonly linkedCountText = linkedCountText;
  /** The card groups test entries (per station when `withStations`): how many carry a design context link. */
  get linkedTestCount(): number {
    const entries = this.data?.type === 'withStations'
      ? (this.data?.list || []).flatMap((station: { list?: unknown[] }) => station?.list || [])
      : this.data?.list;
    return linkedRecordCount(entries);
  }
  matchedId: any;
  matchedNo: any;
  widgetIds: any = [];
  itemIds: any = [];
  displayMatched: boolean;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    if (this.data?.type === 'withStations') {
      this.data?.list?.forEach((item) => {
        item?.list?.forEach((o) => {
          this.itemIds?.push(o?.id);
        });
      });
    } else {
      this.data?.list.forEach((item) => {
        this.itemIds?.push(item?.id);
      });
    }

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp && qp['matchedId']) {
          this.matchedId = qp['matchedId'];

          if (!Array.isArray(this.matchedId)) {
            this.matchedId = [this.matchedId];
          }

          if (this.matchedId?.length) {
            this.matchedId?.forEach((item) => {
              this.widgetIds?.push(item?.split('_')?.[1]);
            });
          }

          const tempData = this.matchedId?.filter((item) => {
            const parts = item?.split('_');
            return parts?.length === 3 && this.itemIds?.includes(parts[1]);
          });
          this.matchedNo = tempData[0]?.split('_')?.[2];
        }

        this.setDisplayMatched();
      });
  }

  setDisplayMatched() {
    if (this.itemIds?.length && this.widgetIds?.length) {
      const widgetSet = new Set(this.widgetIds);
      if (this.itemIds.find(id => widgetSet.has(id))) {
        this.displayMatched = true;
      }
    }

    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}

